import { SkeletonArea } from 'components/skeletonArea';
import { selectIsMenuLoading, selectMenuData } from 'features/ippica/selectors';
import { TabValue } from 'features/ippica/types';
import { useTypedSelector } from 'lib/centralStore';
import React from 'react';
import { capitalize, isTruthy } from 'utility/functions';
import { IppicaNavAntepostRow } from '../ippicaNavAntepostRow';
import { IppicaNavContentEmpty } from '../ippicaNavContentEmpty';

export const IppicaNavTabAntePost = () => {
  const type = TabValue.ANTEPOST;

  const data = useTypedSelector((state) => selectMenuData(state, type));
  const isLoading = useTypedSelector((state) => selectIsMenuLoading(state, type));

  if (isLoading && !isTruthy(data?.length)) return <SkeletonArea height={'58.8'}></SkeletonArea>;

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {isTruthy(data?.length) ? (
        data.map(({ image, titolo, ippodromi }, index) => (
          <React.Fragment key={`${titolo}_${index}`}>
            {ippodromi &&
              ippodromi?.map((ippodromo, indexIppodromo) => {
                const { corse, descrizioneRiunione, siglaRiunione } = ippodromo;
                return (
                  <React.Fragment key={`${descrizioneRiunione}_${indexIppodromo}`}>
                    {corse &&
                      corse.map((corsa, indexCorsa) => (
                        <IppicaNavAntepostRow
                          key={`${corsa.descrizioneAvvenimento}_${indexCorsa}`}
                          codiceProgramma={ippodromo.codiceProgramma}
                          numeroAvvenimento={corsa.numeroAvvenimento}
                          tipoIppica={corsa.tipoIppica}
                          titolo={capitalize(corsa.descrizioneAvvenimento!)!}
                          ippodromo={descrizioneRiunione}
                          siglaRiunione={siglaRiunione}
                          image={image}
                          data={corsa.dataOraAvvenimento}
                          codiceStatoAvvenimento={corsa?.codiceStatoAvvenimento}
                        />
                      ))}
                  </React.Fragment>
                );
              })}
          </React.Fragment>
        ))
      ) : (
        <IppicaNavContentEmpty key={TabValue.ANTEPOST} />
      )}
    </React.Fragment>
  );
};
